exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 896px) {\n.copyright-form-control[data-v-2c3dabb4] {\n    width: 80%;\n}\n}\n\n", ""]);

// exports
